export default "__VITE_ASSET__B7p2JL25__"